import { useEffect, useRef } from 'react';
import { Copy, Trash2, RotateCw, ArrowRightLeft } from 'lucide-react';

export default function ContextMenu({ x, y, onClose, onCopy, onDelete, onRotate, onReplace }) {
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) onClose();
    };
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('mousedown', onClick);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onClick);
      document.removeEventListener('keydown', onKey);
    };
  }, [onClose]);

  const items = [
    onCopy && { icon: Copy, label: 'Копировать', shortcut: 'Ctrl+C', action: onCopy },
    onRotate && { icon: RotateCw, label: 'Повернуть 90°', shortcut: 'R', action: onRotate },
    onReplace && { icon: ArrowRightLeft, label: 'Заменить...', action: onReplace },
    onDelete && { icon: Trash2, label: 'Удалить', shortcut: 'Del', action: onDelete, danger: true },
  ].filter(Boolean);

  const vw = typeof window !== 'undefined' ? window.innerWidth : 1024;
  const vh = typeof window !== 'undefined' ? window.innerHeight : 768;
  const MENU_W = 200, MENU_H = items.length * 32 + 8;
  const left = Math.min(x, vw - MENU_W - 8);
  const top = Math.min(y, vh - MENU_H - 8);

  return (
    <div
      ref={ref}
      className="fixed z-[1000] bg-white rounded-sm border border-[#E0DDD8] shadow-lg py-1 min-w-[200px]"
      style={{ left, top }}
      data-testid="context-menu"
      onContextMenu={(e) => e.preventDefault()}
    >
      {items.map((it) => (
        <button
          key={it.label}
          onClick={() => { it.action(); onClose(); }}
          className={`w-full flex items-center gap-2 px-3 py-1.5 text-xs text-left hover:bg-[#F4F1ED] transition-colors ${
            it.danger ? 'text-red-500 hover:bg-red-50' : 'text-[#1C1C1C]'
          }`}
          data-testid={`ctx-${it.label}`}
        >
          <it.icon className="w-3.5 h-3.5" />
          <span className="flex-1">{it.label}</span>
          {it.shortcut && <span className="mono-text text-[9px] text-[#5C5C5C]/70">{it.shortcut}</span>}
        </button>
      ))}
    </div>
  );
}
